import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=5555738c&scoped=true"
import script from "./Basics.vue?vue&type=script&lang=js"
export * from "./Basics.vue?vue&type=script&lang=js"
import style0 from "./Basics.vue?vue&type=style&index=0&id=5555738c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555738c",
  null
  
)

export default component.exports